<template>
  <v-layout v-if="pagination.pageCount > 0" row wrap class="pa-2">
    <v-flex xs12 sm4 md6 class="d-flex justify-end align-center text-xs-center text-sm-left">
      <div>
        {{ (pagination.pageNo - 1) * pagination.pageSize + 1 }}
        -
        {{ (pagination.pageNo * pagination.pageSize > pagination.total) ? pagination.total : pagination.pageNo * pagination.pageSize }}
        件
        /
        {{ pagination.total }}
        件
      </div>
    </v-flex>
    <v-flex v-if="pagination.pageCount > 0" xs12 sm8 md6 class="justify-end align-center text-xs-center text-sm-right">
      <v-pagination
        v-if="pagination"
        v-model="page"
        :length="+pagination.pageCount"
        :total-visible="5"
        circle
        @input="pageUpdated"
      ></v-pagination>
    </v-flex>
  </v-layout>

</template>

<script>
export default {
  props: {
    value: {},
    pagination: {},
  },
  data() {
    return {
      page: 1,
    }
  },
  watch: {
    value(val) {
      if (this.page != val) this.page = val;
    },
  },
  methods: {
    pageUpdated() {
      this.$emit('input', this.page);
    },
  },
}
</script>
